import React from 'react'
import { Stack, Typography } from '@sureco/design-system'
import { Button } from '@surecompanies/core_components'

function Error({ retry, error }: { retry: () => void; error?: any }) {
  return (
    <Stack>
      <Typography size={20} bold color="red">
        Error loading data
      </Typography>
      <Typography>{error?.message || 'Something went wrong'}</Typography>
      <Stack padding={20} align="center">
        <Button onClick={retry} size="large">
          Retry
        </Button>
      </Stack>
    </Stack>
  )
}

export default Error
